import Compressor from "compressorjs";
import { getAPI, postAPI, putAPI, deleteAPI, getAxiosInstance, getAccessToken } from "../..";

import config from "../../../utils/config";
import {
  APPROVED_IMAGES_URL,
  DELETE_IMAGES_PERMANENTLY,
  SCHEMA_DETAIL_URL,
  SCHEMA_URL,
  UPDATE_WORKFLOW_URL,
  UPLOAD_FILE_URL,
  USER_IMAGES_CARD_URL,
  USER_IMAGE_UNDER_REVIEW_CARDS_URL,
  WORKFLOW_URL,
  DELETE_EVENT_DETAILS,
  DELETE_IMAGE_REVIEW,
  HOTEL_EMAIL_ENQUIRY,
  USER_LISTING,
  USER_ACCESS_REQUESTS_LISTING,
  USER_ACCESS_REQUESTS_UPDATE,
  USER_ACCESS_REQUESTS,
  GET_EVENT_USER_REQUESTS_STATUS,
  CHECK_EVENT_COORDINATOR,
  CREATE_SURVEY_FORM,
  EDIT_SURVEY_FORM,
  GET_SURVEY_FORM_DETAILS,
  GET_SURVEY_FORM_DETAILS_BY_ID,
  SUBMIT_SURVEY_FORM,
  GET_SURVEY_FORM_RESPONSES,
} from "../../url";
import { LoaderAnimation } from "../../../components/spinner";

export const getWorkflowAPI = async () => {
  let response = await getAPI(config.workflowUrl + WORKFLOW_URL);
  return response;
};

export const getSchemaAPI = async () => {
  let response = await getAPI(config.workflowUrl + SCHEMA_URL);
  return response;
};

export const getSchemaDetailsAPI = async (schema_id) => {
  let response = await getAPI(
    config.workflowUrl + SCHEMA_DETAIL_URL + schema_id
  );
  return response;
};

export const uploadFileAPI = async (files, type = "file", upload_type) => {
  if (files && files.length > 0) {
    const responses = await Promise.all(
      files.map(async (file) => {
        if (file.lastModified) {
          let postData = new FormData();

          let uploadFile = file;
          if (type === "image") {
            new Compressor(file, {
              quality: 0.2,
              success: (compressedResult) => {
                uploadFile = compressedResult;
              },
            });
          }

          let url =
            upload_type === "event" || upload_type === "mice"
              ? config.workflowUrl +
                UPLOAD_FILE_URL +
                "?type=" +
                upload_type +
                "_expense"
              : config.workflowUrl + UPLOAD_FILE_URL + "?type=" + upload_type;

          postData.append("file", uploadFile);
          let response = await postAPI(url, postData, false);
          return response;
        }
      })
    );
    return responses;
  }
};

export const updateWorkflowAPI = async (details, workflow_id, step_id) => {
  let payload = {
    instance: details,
  };

  let response = await postAPI(
    config.workflowUrl + UPDATE_WORKFLOW_URL + workflow_id + "/step/" + step_id,
    payload
  );
  return response;
};

export const putWorkflowAPI = async (
  details,
  workflow_id,
  step_id,
  event_id,
  action_name
) => {
  let payload = {
    instance: [details],
  };

  let response = await putAPI(
    config.workflowUrl +
      UPDATE_WORKFLOW_URL +
      workflow_id +
      "/step/" +
      step_id +
      "?workflow_instance_id=" +
      event_id +
      "&action_name=" +
      action_name,
    payload
  );
  return response;
};

export const putReviewflowAPI = async (
  details,
  workflow_id,
  step_id,
  event_id,
  action_name
) => {
  let payload = {
    instance: details,
  };

  let response = await putAPI(
    config.workflowUrl +
      UPDATE_WORKFLOW_URL +
      workflow_id +
      "/step/" +
      step_id +
      "?workflow_instance_id=" +
      event_id +
      "&action_name=" +
      action_name,
    payload
  );
  return response;
};

export const getApprovedImages = async (event_id, page_no, per_page) => {
  let response = await getAPI(
    config.quicklinkUrl +
      APPROVED_IMAGES_URL +
      event_id +
      `&page=${page_no}&per_page=${per_page}`
  );
  return response;
};

export const getUserImagesCards = async (event_id, type) => {
  let response = await getAPI(
    config.quicklinkUrl +
      USER_IMAGES_CARD_URL +
      event_id +
      `&type=${type}&page=1&per_page=100000`
  );
  return response;
};

export const deleteImagesPermanently = async (body) => {
  let response = await postAPI(
    config.quicklinkUrl + DELETE_IMAGES_PERMANENTLY,
    body
  );
  return response;
};

export const getUserImagesUnderReviewCards = async (event_id) => {
  let response = await getAPI(
    config.quicklinkUrl +
      USER_IMAGE_UNDER_REVIEW_CARDS_URL +
      event_id +
      `&page=1&per_page=100000`
  );
  return response;
};

export const editAttendeeAPI = async (
  workflow_id,
  step_id,
  workflow_instance_id,
  details
) => {
  let payload = {
    instance: [details]
  };

  let response = await putAPI(
    config.workflowUrl +
      UPDATE_WORKFLOW_URL +
      workflow_id +
      '/step/' +
      step_id +
      '?workflow_instance_id=' +
      workflow_instance_id +
      '&action_name=EDIT_ATTENDEE',
    payload
  );
  return response;
};

// Delete Event Details

export const deleteEventDetailsAPI = async (event_id) => {
  let response = await deleteAPI(
    config.workflowUrl + DELETE_EVENT_DETAILS + '?event_id=' + event_id
  );
  return response;
};

// Delete Image Review

export const deleteImageReviewAPI = async (data) => {
  
  const axiosInstance = getAxiosInstance(config.workflowUrl + DELETE_IMAGE_REVIEW);
  try {
    const access_token = getAccessToken();
    const config = {
      headers: {
        "x-access-token": access_token,
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      data: data, // Add the body as data property for DELETE requests
    };
    
    const response = await axiosInstance.delete(DELETE_IMAGE_REVIEW, config);    
    // Check if response has data and status
    if (response && response?.data) {
      // If the response has a message property, it's likely a success
      if (response?.data?.message) {
        return { data: response?.data, error: false };
      }
      // If response has data but no message, still consider it success
      return { data: response?.data, error: false };
    }
    
    // If no data in response, check status
    if (response && response?.status >= 200 && response?.status < 300) {
      return { data: { message: "Images deleted successfully" }, error: false };
    }
    
    return { error: true, message: "Failed to delete images" };
  } catch (res) {
    if (res && res.response && res.response.data && res.response.data.message) {
      return { error: true, message: res.response.data.message };
    }
    return { error: true, message: "Something went wrong" };
  }
};

export const sendHotelEnquiryEmailAPI = async (payload) => {
  let response = await postAPI(
    config.workflowUrl + HOTEL_EMAIL_ENQUIRY,
    payload
  );
  return response;
};

export const getUserListingAPI = async (page = 1, per_page = 10, search = '', role = '') => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());
  
  if (search) {
    queryParams.append('search', search);
  }
  
  if (role) {
    queryParams.append('role', role);
  }
  
  const url = `${config.authUrl}${USER_LISTING}?${queryParams.toString()}`;
  let response = await getAPI(url);
  return response;
};

export const updateUserDetailsAPI = async (user_id, userData) => {
  if (!user_id) {
    return { error: true, message: "User ID is required" };
  }

  const payload = userData;
  let response = await putAPI(
    config.authUrl + USER_LISTING + '/' + user_id,
    payload
  );
  return response;
};

// User Access Requests

export const getEventRequestedUsersListingAPI = async (page = 1, per_page = 10, search = '') => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());
  
  if (search) {
    queryParams.append('search', search);
  }
  
  const url = `${config.quicklinkUrl}${USER_ACCESS_REQUESTS_LISTING}?${queryParams.toString()}`;
  let response = await getAPI(url);
  return response;
};


export const updateUserEventAccessRequest = async (user_id, event_id, access_for_event) => {
  if (!user_id) {
    return { error: true, message: "User ID is required" };
  }

  if (!event_id) {
    return { error: true, message: "Event ID is required" };
  }

  if (!access_for_event) {
    return { error: true, message: "Access status is required" };
  }

  const payload = {
    user_id,
    event_id,
    access_for_event
  };

  let response = await postAPI(
    config.quicklinkUrl + USER_ACCESS_REQUESTS_UPDATE,
    payload
  );
  return response;
};

export const requestEventAccessAPI = async (event_id) => {
  if (!event_id) {
    return { error: true, message: "Event ID is required" };
  }

  const queryParams = new URLSearchParams();
  queryParams.append('event_id', event_id);
  
  const url = `${config.workflowUrl}${USER_ACCESS_REQUESTS}?${queryParams.toString()}`;
  let response = await postAPI(url, {});
  return response;
};

export const getEventUserRequestStatusAPI = async (event_id, user_id) => {
  if (!event_id) {
    return { error: true, message: "Event ID is required" };
  }

  if (!user_id) {
    return { error: true, message: "User ID is required" };
  }

  const queryParams = new URLSearchParams();
  queryParams.append('event_id', event_id);
  queryParams.append('user_id', user_id);
  
  const url = `${config.quicklinkUrl}${GET_EVENT_USER_REQUESTS_STATUS}?${queryParams.toString()}`;
  let response = await getAPI(url);
  return response;
};

// Survey Form

// 1. Check Event Coordinator API
export const checkEventCoordinatorAPI = async (response_type = null) => {
  let url = config.workflowUrl + CHECK_EVENT_COORDINATOR;
  
  if (response_type) {
    url += `?response_type=${response_type}`;
  }
  
  let response = await getAPI(url);
  return response;
};

// 2. Create Survey Form API
export const createSurveyFormAPI = async (surveyData) => {
  if (!surveyData) {
    return { error: true, message: "Survey data is required" };
  }

  let payload = {
    title: surveyData.title,
    type: surveyData.type,
    event_id: surveyData.event_id,
    questions: surveyData.questions
  };

  let response = await postAPI(
    config.quicklinkUrl + CREATE_SURVEY_FORM,
    payload
  );
  return response;
};

// 3. Edit Survey Form API
export const editSurveyFormAPI = async (survey_id, surveyData) => {
  if (!survey_id) {
    return { error: true, message: "Survey ID is required" };
  }

  if (!surveyData) {
    return { error: true, message: "Survey data is required" };
  }

  let payload = {
    title: surveyData.title,
    type: surveyData.type,
    event_id: surveyData.event_id,
    questions: surveyData.questions
  };

  let response = await putAPI(
    config.quicklinkUrl + EDIT_SURVEY_FORM + "/" + survey_id,
    payload
  );
  return response;
};

// 4. Get Survey Form Details API
export const getSurveyFormsDetails = async (page = 1, per_page = 10) => {
  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());
  
  const url = `${config.quicklinkUrl}${GET_SURVEY_FORM_DETAILS}?${queryParams.toString()}`;
  let response = await getAPI(url);
  return response;
};

// 5. Get Particular Survey Form Details API
export const getSurveyFormDetailsById = async (survey_id) => {
  if (!survey_id) {
    return { error: true, message: "Survey ID is required" };
  }
  
  let response = await getAPI(
    config.quicklinkUrl + GET_SURVEY_FORM_DETAILS_BY_ID + "/" + survey_id
  );
  return response;
};

// 6. Submit Survey Response API
export const submitSurveyResponseAPI = async (token, responseData) => {
  if (!token) {
    return { error: true, message: "Token is required" };
  }

  if (!responseData) {
    return { error: true, message: "Response data is required" };
  }

  let payload = {
    survey_id: responseData.survey_id,
    answers: responseData.answers
  };

  const queryParams = new URLSearchParams();
  queryParams.append('token', token);
  
  const url = `${config.quicklinkUrl}${SUBMIT_SURVEY_FORM}?${queryParams.toString()}`;
  let response = await postAPI(url, payload);
  return response;
};
